import { Css } from "~generated/css";

type ImageDisclaimerProps = {
  title: string;
};
export const ImageDisclaimer = ({ title }: ImageDisclaimerProps) => (
  <div
    css={{
      ...Css.absolute.z1
        .w("max-content")
        .maxw("calc(100% - 32px)") // 32px from px2
        .bottomPx(24)
        .left("50%")
        .add("transform", "translate(-50%)")
        .br4.py1.px2.bgColor("rgba(246, 246, 240, 0.8)").$, // translucent `OffWhite`
      ...Css.ifMobile.w100.bottom0.maxw100.br0.$,
    }}
  >
    <span css={Css.t12.dib.add("fontStyle", "italic").$}>
      <span css={Css.fw700.$}>Please Note:</span>&nbsp;{title}
    </span>
  </div>
);
